import _ from "lodash";
import SearchIcon from '@mui/icons-material/Search';
import { ColleagueFinderStyles } from "../Dashboard-styles";
import CustomizedTreeView from './TreeView'
import { API_CODE } from "../../../common/utils/const";
import { staffServ } from "../../../services";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { TextField, Typography } from "@mui/material";
import {isMobile} from 'react-device-detect';

export default function ColleagueFinder() {
  const tempData = useRef([]);
  const auth = useSelector((state) => state.auth);
  const [treeData, setTreeData] = useState([]);

  useEffect(() => {
    const init = async () => {
      await getUsers();
    };
    init();
  }, []);

  const getUsers = async () => {
    try {
      const params = {
        id: auth.user.profile.id
      }
      // const { data, errMsg, errCode } = await staffServ.getUsers(params);
      const { data, errMsg, errCode } = await staffServ.getUsers(params);
      if (data && errCode == API_CODE.SUCCESS) {
        // const _data = data.filter(x => x.user_id != auth.user.profile.id);
        

        if (data.length > 0) {
          _handleTreeData(data);
          tempData.current = data;
        }
      }
    } catch (error) { }

  };

  const _handleTreeData = (data) => {
    const groupByDepartment = _.groupBy(data, 'department');
    const _treeData = [];
    const getChildrens = () => {
      const child = [];
      let count = 0;

      const departmentKey = _.sortBy(Object.keys(groupByDepartment));
      for (const key of departmentKey) {
        if (key != 'null') {
          const departmentId = `department_${count}`;
          child.push({
            id: departmentId,
            label: groupByDepartment[key][0].department,
            children: _.orderBy(groupByDepartment[key], [user => user.displayName.toLowerCase()], ['asc']).map(x => {
              return {
                label: `${x.displayName}${x.updated_by}`,
                ...x
              }
            })
          })
        }else{
          groupByDepartment[key]?.map((item, index) => {
            const departmentId = `department_${count}_${index}`;
            child.push({
              id: departmentId,
              label: `${item.displayName}${item.updated_by}`,
              children: [item]
            })
          })
        }
        count++;
      }
      return child;
    }
    if(data.length > 0){
      const companyId = 'company';
      _treeData.push({
        id: companyId,
        label: data[0].companyName,
        children: getChildrens()
      })
      setTreeData(_treeData);
    }else{
      setTreeData([]);
    }
  }

  function filterBy(arr, query) {
    if(!query) return _handleTreeData(arr);
    const newData = arr?.filter(value => value.displayName?.toLowerCase().includes(query.toLowerCase()));
    console.log(newData);
    return _handleTreeData(newData);
  }

  const renderMenu = (className) => {
    return (
      <div className={className}>
          <div
            className={`normal active colleague-finder`}
          >
            <div style={{ textAlign: "center" }} >
              <SearchIcon />
            </div>
            <div style={{ textAlign: "center" }} >
              <span style={{ fontSize: "14px" }}>Colleague Finder</span>
            </div>
          </div>
        </div>
    )
  }

  return (
    <div style={{ width: '100%' }}>
      {
        isMobile && 
        <div className="block-tab">
          {renderMenu('tab')}
        </div>
      }

      {
        !isMobile &&
        <div className="menu-left">
          {renderMenu('tab-desktop')}
        </div>
      }
      <div className={isMobile ? 'main' : 'main-desktop'}>
        <ColleagueFinderStyles>
          <div className="search">
            <Typography>Colleague name</Typography>
            <TextField
              className="search"
              variant="outlined"
              size="small"
              onChange={(e) => { filterBy(tempData.current, e.target.value) }}
            />
          </div>
          <CustomizedTreeView treeData={treeData} isMobile={isMobile}/>
        </ColleagueFinderStyles>
      </div>
    </div>
  );
}
